<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M14.0235 2.15623C14.0235 0.965379 13.1176 0 12.0001 0C10.8826 0 9.97672 0.965379 9.97672 2.15623C9.97672 3.34709 10.8826 4.31247 12.0001 4.31247C13.1176 4.31247 14.0235 3.34709 14.0235 2.15623ZM15.2831 2.94775C16.4892 3.23416 17.3951 4.37937 17.3951 5.75V8.62501C17.3951 9.41746 16.7898 10.0625 16.0462 10.0625C15.3025 10.0625 14.6972 9.41746 14.6972 8.62501V7.18751H9.30143V8.62501C9.30143 9.41746 8.69611 10.0625 7.95247 10.0625C7.20884 10.0625 6.60352 9.41746 6.60352 8.62501V5.75C6.60352 4.37937 7.50932 3.23416 8.71552 2.94775C9.05562 4.54854 10.3958 5.75 11.9993 5.75C13.6028 5.75 14.943 4.54854 15.2831 2.94775ZM6.95959 11.7457C6.58777 11.0594 5.7609 10.8234 5.1169 11.2196L2.78051 12.6571C1.66654 13.3424 1.18875 14.751 1.55918 16.0073C3.03014 15.5208 4.67666 16.1568 5.47843 17.6367C6.28019 19.1167 5.97383 20.9541 4.84296 22.0684C5.67874 23.0383 7.06233 23.3017 8.1763 22.6164L10.5127 21.1789C11.1567 20.7827 11.3782 19.9015 11.0064 19.2152C10.6346 18.5289 9.80773 18.2929 9.16373 18.689L7.99549 19.4078L5.29757 14.4281L6.46581 13.7094C7.10986 13.3132 7.33137 12.432 6.95959 11.7457ZM18.8844 11.2196C18.2403 10.8233 17.4135 11.0594 17.0417 11.7458C16.6699 12.4321 16.8914 13.3132 17.5355 13.7094L18.7037 14.4281L16.0058 19.4078L14.8375 18.6891C14.1935 18.2928 13.3667 18.5289 12.9948 19.2152C12.623 19.9016 12.8446 20.7827 13.4886 21.1789L15.825 22.6164C16.939 23.3017 18.3226 23.0383 19.1583 22.0684C18.0275 20.9541 17.7211 19.1166 18.5229 17.6367C19.3246 16.1568 20.9711 15.5208 22.4421 16.0073C22.8125 14.751 22.3347 13.3424 21.2208 12.6571L18.8844 11.2196ZM19.6913 18.3553C20.2501 17.324 21.4876 16.9707 22.4554 17.5661C23.4232 18.1615 23.7998 19.4802 23.241 20.5116C22.6823 21.5428 21.3998 21.8962 20.432 21.3008C19.4642 20.7054 19.1326 19.3866 19.6913 18.3553ZM4.31004 18.3554C3.75126 17.3241 2.5138 16.9707 1.54595 17.5663C0.578203 18.1617 0.201578 19.4804 0.760406 20.5117C1.3191 21.543 2.60162 21.8964 3.56937 21.3009C4.53721 20.7055 4.86878 19.3867 4.31004 18.3554Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgHRLFABoardOfDirectors',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>